// src/pages/UserProfile/SettingsPage.jsx
import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  PersonFill,
  ShieldLockFill,
  BellFill,
  BoxArrowRight,
  TrashFill,
} from "react-bootstrap-icons";
import { facultyLevelsMap } from "./Activities/AddActivity";
import {
  // getMyProfile,
  updatePersonal,
  createProfileRequest,
  getMyProfileRequests,
  updatePassword,
  SendOTP,
  resetPasswordWithOTP,
  toggleNotificatio,
  confirmDeleteAccountAPI,
} from "../services/profileSettings.js"; // تأكد المسار في مشروعك
import { getUser } from "../services/userService.js";
import ConfirmModal from "../components/ConfirmModal.jsx";
import PopupMessage from "../components/common/PopupMessage.js";
import { logout } from "../services/api.js";
import { AuthContext } from "../context/AuthContext.js";
import { useNavigate } from "react-router-dom";

// Human-friendly labels to show in UI (key = value stored, label = shown)
const facultyOptions = [
  { key: "COMPUTER_SCIENCE", label: "Computer Science" },
  { key: "ENGINEERING", label: "Engineering" },
  { key: "MEDICINE", label: "Medicine" },
  { key: "DENTISTRY", label: "Dentistry" },
  { key: "PHARMACY", label: "Pharmacy" },
  { key: "NURSING", label: "Nursing" },
  { key: "PHYSIOTHERAPY", label: "Physiotherapy" },
  { key: "FINE_ARTS", label: "Fine Arts" },
  { key: "BUSINESS_ADMINISTRATION", label: "Business Administration" },
  { key: "MEDIA_AND_APPLIED_LANGUAGES", label: "Media & Applied Languages" },
];

export default function SettingsPage() {
  // const [notifications, setNotifications] = useState(true);
  const [otpStep, setOtpStep] = useState(false);
  const [deleteOtpStep, setDeleteOtpStep] = useState(false);
  const [deleteOtpLoading, setDeleteOtpLoading] = useState(false);
  const [deleteOtpMessage, setDeleteOtpMessage] = useState(null);
  const [deleteOtpError, setDeleteOtpError] = useState(null);
  const [deleteOtpRemaining, setDeleteOtpRemaining] = useState(null);
  const [loadingAction, setLoadingAction] = useState("");
  const [message, setMessage] = useState("");

  const [myRequests, setMyRequests] = useState([]);

  // Form states
  const [passwords, setPasswords] = useState({
    old: "",
    newPassword: "",
    confirm: "",
  });
  const [otpData, setOtpData] = useState({
    otp: "",
    newPass: "",
    confirmPass: "",
  });
  const [personal, setPersonal] = useState({
    name: "",
    phone: "",
    level: "",
    faculty: "",
    universtyID: "",
  });

  // availableLevels derived from faculty
  const [availableLevels, setAvailableLevels] = useState([]);

  // Request-change state for sensitive fields
  const [requestOpen, setRequestOpen] = useState({
    faculty: false,
    level: false,
    universtyID: false,
  });
  const [requestPayload, setRequestPayload] = useState({
    field: "",
    newValue: "",
    reason: "",
  });

  // keep initial values to detect dirty state
  const [initialPersonal, setInitialPersonal] = useState({
    name: "",
    phone: "",
    level: "",
    faculty: "",
    universtyID: "",
  });

  // Validation states
  const [errors, setErrors] = useState({});

  const [showConfirm, setShowConfirm] = useState(false);
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  const [otpLoading, setOtpLoading] = useState(false);
  const [otpMessage, setOtpMessage] = useState(null); // success/info messages
  const [otpError, setOtpError] = useState(null); // error messages
  const [otpRemaining, setOtpRemaining] = useState(null); // optional
  const [notificationStatus, setNotificationStatus] = useState(null);
  const [notifLoading, setNotifLoading] = useState(false);
  const [notifError, setNotifError] = useState(null);

  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  //////////////////////////////////////////////////////////////////

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const res = await getMyProfileRequests();
        setMyRequests(res || []);
      } catch (err) {
        console.error("Failed to load requests", err);
      }
    };

    fetchRequests();
  }, []);

  const getRequestForField = (field) => {
    return myRequests.find((r) => r.field === field);
  };

  // ------------------------------
  // Load real initial profile
  // ------------------------------
  useEffect(() => {
    let mounted = true;
    const loadProfile = async () => {
      setLoadingAction("Loading profile");
      try {
        const res = await getUser(); // expects { data: { name, phone, faculty, level, universtyID } }
        setNotificationStatus(res.data?.notificationStatus);
        const payload = res?.data || res || {};
        const p = {
          name: payload.fullName || "",
          phone: payload.phone || "",
          level: payload.level || "",
          faculty: payload.faculty || "",
          universtyID: payload.universtyID || "",
        };

        if (!mounted) return;

        setPersonal(p);
        setInitialPersonal(p);
        setAvailableLevels(buildLevelsForFaculty(p.faculty));
      } catch (err) {
        // fallback to safe defaults if API fails (do not break UI)
        console.error("Failed to load profile:", err);
        // Keep existing dummy values if any; do not crash
      } finally {
        if (mounted) setLoadingAction("");
      }
    };

    loadProfile();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- دالة مساعدة للمقارنة (trim لتفادي مسافات)
  const isPersonalDirty = () => {
    const trim = (v) => (v ?? "").toString().trim();
    return (
      trim(personal.name) !== trim(initialPersonal.name) ||
      trim(personal.phone) !== trim(initialPersonal.phone)
    );
  };

  // --------------------
  // Helpers
  // --------------------
  const buildLevelsForFaculty = (facultyKey) => {
    if (!facultyKey) return [];
    const years = facultyLevelsMap[facultyKey] || 0;
    return Array.from({ length: years }, (_, i) => `LEVEL_${i + 1}`);
  };

  // --------------------
  // Validation logic
  // --------------------
  const validateField = (name, value) => {
    let err = "";

    if (name === "phone") {
      const regex = /^(?:\+20|0)?1[0-9]{9}$/;
      if (!value) err = "Phone is required";
      else if (value && !regex.test(value))
        err = "Invalid Egyptian phone number";
    }

    if (name === "name") {
      const v = (value ?? "").toString().trim();
      if (!v) err = "Full name is required";
      else if (v.length < 6) err = "Name must be at least 6 characters";
      else if (v.length > 30) err = "Name must be at most 30 characters";
    }

    if (name === "newPassword" || name === "confirm" || name === "old") {
      if (value && (value.length < 6 || value.length > 30))
        err = "Password must be between 6 and 30 characters";

      if (
        name === "confirm" &&
        passwords.newPassword &&
        value !== passwords.newPassword
      )
        err = "Passwords do not match";

      if (
        (name === "newPassword" && passwords.old && value === passwords.old) ||
        (name === "old" &&
          passwords.newPassword &&
          value === passwords.newPassword)
      ) {
        err = "New password must be different from old password";
      }
    }

    if (name === "newPass" || name === "confirmPass") {
      if (!value) err = "Password is required";
      else if (value.length < 6 || value.length > 30)
        err = "Password must be between 6 and 30 characters";

      if (
        name === "confirmPass" &&
        otpData.newPass &&
        value !== otpData.newPass
      )
        err = "Passwords do not match";
    }

    if (name === "otp") {
      if (!value) err = "Password is required";
      if (value && !/^\d{6}$/.test(value)) err = "OTP must be 6 digits";
    }

    if (name === "universtyID") {
      if (value && !/^\d{9}$/.test(value))
        err = "University ID must be 9 digits";
    }

    if (name === "newValue") {
      if (!value) err = "Please provide a new value";
      else if (value.length < 1) err = "Value too short";
    }

    if (name === "reason") {
      if (!value) err = "Please explain why you want to change";
      else if (value.length < 6) err = "Reason must be at least 6 characters";
    }

    setErrors((prev) => ({ ...prev, [name]: err }));
    return err === "";
  };

  // --------------------
  // Simulated API action (kept for flows not yet wired)
  // --------------------

  const handleToggleNotification = async () => {
    if (notifLoading) return; // حماية من الدبل كليك

    const oldValue = notificationStatus;

    setNotifLoading(true);
    setNotifError(null);

    try {
      // optimistic update
      setNotificationStatus(!oldValue);

      // call backend (no params)
      const res = await toggleNotificatio();

      // تأكيد القيمة من السيرفر (الأصح)
      if (typeof res.notificationStatus === "boolean") {
        setNotificationStatus(res.notificationStatus);
        if (res.notificationStatus) {
          setPopup({
            show: true,
            type: "info",
            message: "ON",
          });
        } else {
          setPopup({
            show: true,
            type: "info",
            message: "OFF",
          });
        }
      }
    } catch (err) {
      // رجّع القيمة القديمة
      setNotificationStatus(oldValue);
      setNotifError(err?.message || "Failed to update notification setting");
    } finally {
      setNotifLoading(false);
    }
  };

  // const simulateAction = (action, payload) => {
  //   setLoadingAction(action);
  //   setMessage("");
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       setLoadingAction("");
  //       const successMsg = `${action} completed successfully`;
  //       setMessage(successMsg);
  //       resolve({ success: true, message: successMsg });
  //     }, 1100);
  //   });
  // };

  async function LogoutFun() {
    setLoadingAction("Logout");
    const response = await logout();
    if (response.status === 200) {
      setPopup({
        show: true,
        type: "success",
        message: response?.data?.message || "louged out successful!",
      });
      setTimeout(() => {
        setUser(null);
        setLoadingAction("");
        navigate("/");
      }, 1500);
    } else {
      alert(`Error: ${response.data?.message}`);
    }
  }

  // --------------------
  // Handlers
  // --------------------
  const removeReadOnly = (e) => {
    if (
      e &&
      e.target &&
      e.target.hasAttribute &&
      e.target.hasAttribute("readOnly")
    ) {
      e.target.removeAttribute("readOnly");
    }
  };

  // When user changes faculty in personal form, update availableLevels and reset personal.level
  const handleFacultyChange = (e) => {
    const facultyKey = e.target.value;
    setPersonal((p) => ({ ...p, faculty: facultyKey, level: "" }));
    const levels = buildLevelsForFaculty(facultyKey);
    setAvailableLevels(levels);
  };

  const handleSavePersonal = async () => {
    // validate phone and name
    const okPhone = validateField("phone", personal.phone);
    const okName = validateField("name", personal.name);
    if (!okPhone || !okName) {
      setMessage("Please fix the errors before saving.");
      return;
    }
    // If nothing changed, stop
    if (!isPersonalDirty()) {
      setMessage("No changes to save.");
      return;
    }
    setLoadingAction("Profile update");
    setMessage("");
    try {
      // Only send name + phone as required
      const payload = {
        name: personal.name.trim(),
        phone: personal.phone.trim(),
      };
      // call backend update endpoint
      const res = await updatePersonal(payload); // expects { message, data }
      setPopup({
        show: true,
        type: "success",
        message: res?.message,
      });
      setMessage(res?.message || "Profile updated successfully.");
      // update initialPersonal so Save button disables
      setInitialPersonal((prev) => ({
        ...(prev || {}),
        name: payload.name,
        phone: payload.phone,
      }));
    } catch (err) {
      console.error("updatePersonal error:", err);
      const msg = err?.message || err?.msg || "Failed to update profile";
      setMessage(msg);
    } finally {
      setLoadingAction("");
    }
  };

  const openRequest = (field) => {
    const hasPending = myRequests.some(
      (r) => r.field === field && r.status === "PENDING",
    );

    if (hasPending) {
      setMessage("You already have a pending request for this field.");
      return;
    }

    setRequestOpen((p) => ({ ...p, [field]: true }));
    setRequestPayload({ field, newValue: personal[field] || "", reason: "" });
    setErrors((prev) => ({ ...prev, newValue: null, reason: null }));
  };
  const cancelRequest = (field) => {
    setRequestOpen((p) => ({ ...p, [field]: false }));
    setRequestPayload({ field: "", newValue: "", reason: "" });
  };
  const submitRequest = async () => {
    const okValue = validateField("newValue", requestPayload.newValue);
    const okReason = validateField("reason", requestPayload.reason);
    if (!okValue || !okReason) return;
    try {
      setLoadingAction("Profile change request");

      const res = await createProfileRequest({
        field: requestPayload.field,
        newValue: requestPayload.newValue,
        reason: requestPayload.reason,
      });
      setPopup({
        show: true,
        type: "info",
        message: res.message,
      });

      setMessage(res.message);

      // اقفل الفورم
      setRequestOpen({ faculty: false, level: false, universtyID: false });
      setRequestPayload({ field: "", newValue: "", reason: "" });

      // رجّع الطلبات من السيرفر
      const updated = await getMyProfileRequests();
      setMyRequests(updated || []);
    } catch (err) {
      setMessage(err.message || "Failed to submit request");
      setPopup({
        show: true,
        type: "error",
        message: err.message,
      });
    } finally {
      setLoadingAction("");
    }
  };
  // Password flows
  const handleUpdatePassword = async () => {
    const okOld = validateField("old", passwords.old);
    const okNew = validateField("newPassword", passwords.newPassword);
    const okConfirm = validateField("confirm", passwords.confirm);
    if (!okOld || !okNew || !okConfirm) {
      setMessage("Please fix the errors in password fields.");
      return;
    }
    try {
      const res = await updatePassword({ passwords });
      setPopup({
        show: true,
        type: "success",
        message: res?.message || "Password updated successfully",
      });
      setPasswords({ old: "", newPassword: "", confirm: "" });
    } catch (error) {
      setPopup({
        show: true,
        type: "error",
        message: error?.message || "Something went wrong",
      });
    }
  };

  const handleSendOTP = async (type = "resetPassword") => {
    // type: "resetPassword" or "deleteAccount"
    setOtpError(null);
    setOtpMessage(null);
    setOtpRemaining(null);

    setOtpLoading(true);
    try {
      const res = await SendOTP(type); // call api
      // success response from server
      // server returns { message, remainingAttempts } per our design
      setOtpMessage(res.message || "OTP sent successfully");
      setPopup({
        show: true,
        type: "success",
        message: res.message || "OTP sent successfully",
      });
      if (typeof res.remainingAttempts !== "undefined") {
        setOtpRemaining(res.remainingAttempts);
      }
      setOtpStep(true); // show OTP inputs so user can enter code
    } catch (err) {
      const msg = err?.message || "Failed to send OTP";
      setPopup({
        show: true,
        type: "error",
        message: msg || "Failed to send OTP",
      });
      // smart handling based on message
      if (msg.toLowerCase().includes("still valid")) {
        // Backend says: existing OTP not yet expired — let user enter it
        setOtpMessage(msg);
        setOtpStep(true);
      } else if (
        msg.toLowerCase().includes("daily") ||
        msg.toLowerCase().includes("limit") ||
        msg.toLowerCase().includes("429")
      ) {
        // reached daily limit — block further sends, show error
        setOtpError(msg);
        setOtpStep(false);
      } else {
        // generic error — allow user to still open OTP input only if you want:
        // choose to open input or not. Here we'll open it so user can paste an OTP if they already have one
        setOtpError(msg);
        // do NOT call SendOTP again, user must wait or use existing code
      }
    } finally {
      setOtpLoading(false);
    }
  }; // Done

  const handleSendDeleteOTP = async () => {
    setDeleteOtpError(null);
    setDeleteOtpMessage(null);
    setDeleteOtpRemaining(null);

    setDeleteOtpLoading(true);
    try {
      const res = await SendOTP("deleteAccount");

      setDeleteOtpMessage(res.message || "OTP sent successfully");
      setPopup({
        show: true,
        type: "success",
        message: res.message || "OTP sent successfully",
      });
      if (typeof res.remainingAttempts !== "undefined") {
        setDeleteOtpRemaining(res.remainingAttempts);
      }

      setDeleteOtpStep(true); // دي خاصة بالحذف بس
    } catch (err) {
      const msg = err?.message || "Failed to send OTP";

      setPopup({
        show: true,
        type: "error",
        message: msg || "Something went wrong",
      });

      if (msg.toLowerCase().includes("still valid")) {
        setDeleteOtpMessage(msg);
        setDeleteOtpStep(true);
      } else if (
        msg.toLowerCase().includes("daily") ||
        msg.toLowerCase().includes("limit") ||
        msg.toLowerCase().includes("429")
      ) {
        setDeleteOtpError(msg);
        setDeleteOtpStep(false);
      } else {
        setDeleteOtpError(msg);
      }
    } finally {
      setDeleteOtpLoading(false);
    }
  }; // Done

  const handleResetPasswordWithOTP = async () => {
    const okOtp = validateField("otp", otpData.otp);
    const okNewPass = validateField("newPass", otpData.newPass);
    const okConfirmPass = validateField("confirmPass", otpData.confirmPass);

    if (!okOtp || !okNewPass || !okConfirmPass) return;

    try {
      const res = await resetPasswordWithOTP(otpData);

      setPopup({
        show: true,
        type: "success",
        message: res.message,
      });

      setOtpStep(false);
      setOtpData({ otp: "", newPass: "", confirmPass: "" });
    } catch (err) {
      setPopup({
        show: true,
        type: "error",
        message: err.message, // مهم: message مش err نفسه
      });
    }
  }; // Done

  // Delete account
  const handleConfirmDelete = async () => {
    // validate OTP field
    const okOtp = validateField("otp", otpData.otp);
    if (!okOtp) {
      setDeleteOtpError("Please enter the 6-digit OTP");
      return;
    }

    setLoadingAction("Account deletion");
    setDeleteOtpError(null);

    try {
      const res = await confirmDeleteAccountAPI(); // API اللي عملناها للباك

      setDeleteOtpMessage(res?.message || "Account scheduled for deletion");
      setPopup({
        show: true,
        type: "info",
        message: res?.message || "Account scheduled for deletion",
      });

      // فضّي البيانات
      setOtpData({ otp: "", newPass: "", confirmPass: "" });
      setDeleteOtpStep(false);

      await LogoutFun();
    } catch (err) {
      setDeleteOtpError(err?.message || "Failed to delete account");
      setPopup({
        show: true,
        type: "error",
        message: err?.message || "Failed to delete account",
      });
    } finally {
      setLoadingAction("");
    }
  };

  const renderStatusBadge = (field) => {
    const r = getRequestForField(field);
    if (!r) return null;
    const status = r.status || "PENDING";
    const cls =
      status === "APPROVED"
        ? "approved"
        : status === "REJECTED"
          ? "rejected"
          : status === "OPENED_AGAIN"
            ? "opened-again"
            : "pending";
    return (
      <div
        className={`request-badge ${cls}`}
        title={`Status: ${status} • Created: ${new Date(r.createdAt).toLocaleDateString()}`}
      >
        {status === "APPROVED" && <>Approved</>}
        {status === "REJECTED" && <>Rejected</>}
        {status === "OPENED_AGAIN" && <>Re-opened</>}
        {status === "PENDING" && (
          <>
            Pending → <strong>{String(r.newValue).replace(/_/g, " ")}</strong>
          </>
        )}
      </div>
    );
  };

  const renderActionButton = (field) => {
    const r = getRequestForField(field);

    // No request -> show normal "Request change"
    if (!r) {
      return (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => openRequest(field)}
        >
          Request change
        </button>
      );
    }

    // If admin explicitly re-opened
    if (r.status === "OPENED_AGAIN") {
      return (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => openRequest(field)}
        >
          Request change
        </button>
      );
    }

    // PENDING => disabled
    if (r.status === "PENDING") {
      return null;
    }

    // APPROVED => hide button (user already changed)
    if (r.status === "APPROVED") {
      return null;
    }

    // REJECTED (locked unless OPENED_AGAIN) => show locked disabled with tooltip
    if (r.status === "REJECTED") {
      return null;
    }

    return null;
  };

  // --------------------
  // Render
  // --------------------
  return (
    <>
      <div
        style={{
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
          paddingTop: "110px",
          paddingBottom: "40px",
        }}
      >
        <div className="container px-3 px-md-4" style={{ maxWidth: "900px" }}>
          {/* Hidden fake inputs to absorb browser autofill attempts */}
          <div style={{ height: 0, width: 0, overflow: "hidden" }}>
            <input autoComplete="username" name="fakeuser" />
            <input
              autoComplete="new-password"
              name="fakepass"
              type="password"
            />
          </div>

          <h2
            className="text-center fw-bold mb-5 fs-3 fs-md-1"
            style={{ color: "#0d6efd" }}
          >
            ⚙️ Account Settings
          </h2>

          {message && (
            <div className="alert alert-success text-center py-2">
              {message}
            </div>
          )}

          {/* PERSONAL INFO */}
          <section className="mb-4 bg-white p-3 p-md-4 rounded-4 shadow-sm">
            <h4
              className="mb-4 fw-semibold d-flex align-items-center"
              style={{ color: "#0d6efd", fontSize: "1.2rem" }}
            >
              <PersonFill className="me-2" size={22} /> Personal Information
            </h4>

            <div className="row g-3">
              {/* Full Name */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold small">
                  Full Name
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  className={`form-control shadow-sm border-0 bg-light ${
                    errors.name ? "is-invalid" : ""
                  }`}
                  placeholder="Enter your full name"
                  value={personal.name}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPersonal({ ...personal, name: value });
                    validateField("name", value);
                  }}
                />
                {errors.name && (
                  <div className="invalid-feedback small">{errors.name}</div>
                )}
              </div>

              {/* Phone */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold small">
                  Phone Number
                </label>
                <input
                  type="text"
                  autoComplete="off"
                  className={`form-control shadow-sm border-0 bg-light ${
                    errors.phone ? "is-invalid" : ""
                  }`}
                  placeholder="01xxxxxxxxx"
                  value={personal.phone}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPersonal({ ...personal, phone: value });
                    validateField("phone", value);
                  }}
                  readOnly
                  onFocus={removeReadOnly}
                />
                {errors.phone && (
                  <div className="invalid-feedback small">{errors.phone}</div>
                )}
              </div>

              {/* LEVEL */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold small">
                  Level / Year
                </label>

                {/* layout: on small screens stack vertical; on md+ align inline */}
                <div className="control-row">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <select
                      className="form-select shadow-sm border-0 bg-light w-100"
                      value={personal.level}
                      onChange={(e) =>
                        setPersonal({ ...personal, level: e.target.value })
                      }
                      readOnly
                      onFocus={removeReadOnly}
                    >
                      <option value="">Select your level</option>
                      {availableLevels.length === 0 ? (
                        <option disabled>Choose faculty first</option>
                      ) : (
                        availableLevels.map((lvl) => (
                          <option key={lvl} value={lvl}>
                            {lvl.replace("_", " ")}
                          </option>
                        ))
                      )}
                    </select>
                  </div>

                  <div className="control-actions">
                    {renderStatusBadge("level")}
                    {renderActionButton("level")}
                  </div>
                </div>

                {/* Request form (collapsible area) */}
                {requestOpen.level && (
                  <div className="mt-2 border rounded-3 p-3 bg-light">
                    <label className="form-label small">New Level</label>
                    <select
                      className={`form-select mb-2 ${errors.newValue ? "is-invalid" : ""}`}
                      value={requestPayload.newValue}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          newValue: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select new level</option>
                      {buildLevelsForFaculty(personal.faculty).map((lvl) => (
                        <option key={lvl} value={lvl}>
                          {lvl.replace("_", " ")}
                        </option>
                      ))}
                    </select>
                    {errors.newValue && (
                      <div className="invalid-feedback small">
                        {errors.newValue}
                      </div>
                    )}

                    <label className="form-label small">Reason</label>
                    <textarea
                      className={`form-control mb-2 ${errors.reason ? "is-invalid" : ""}`}
                      rows={2}
                      value={requestPayload.reason}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          reason: e.target.value,
                        }))
                      }
                    />
                    {errors.reason && (
                      <div className="invalid-feedback small">
                        {errors.reason}
                      </div>
                    )}

                    <div className="text-end">
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => setShowConfirm(true)}
                      >
                        Submit Request
                      </button>

                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => cancelRequest("level")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* FACULTY */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold small">Faculty</label>

                <div className="control-row">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <select
                      className="form-select shadow-sm border-0 bg-light w-100"
                      value={personal.faculty}
                      onChange={handleFacultyChange}
                      readOnly
                      onFocus={removeReadOnly}
                    >
                      <option value="">Select your faculty</option>
                      {facultyOptions.map((f) => (
                        <option key={f.key} value={f.key}>
                          {f.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="control-actions">
                    {renderStatusBadge("faculty")}
                    {renderActionButton("faculty")}
                  </div>
                </div>

                {requestOpen.faculty && (
                  <div className="mt-2 border rounded-3 p-3 bg-light">
                    <label className="form-label small">New Faculty</label>
                    <select
                      className={`form-select mb-2 ${errors.newValue ? "is-invalid" : ""}`}
                      value={requestPayload.newValue}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          newValue: e.target.value,
                        }))
                      }
                    >
                      <option value="">Select new faculty</option>
                      {facultyOptions.map((f) => (
                        <option key={f.key} value={f.key}>
                          {f.label}
                        </option>
                      ))}
                    </select>
                    {errors.newValue && (
                      <div className="invalid-feedback small">
                        {errors.newValue}
                      </div>
                    )}

                    <label className="form-label small">Reason</label>
                    <textarea
                      className={`form-control mb-2 ${errors.reason ? "is-invalid" : ""}`}
                      rows={2}
                      value={requestPayload.reason}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          reason: e.target.value,
                        }))
                      }
                    />
                    {errors.reason && (
                      <div className="invalid-feedback small">
                        {errors.reason}
                      </div>
                    )}

                    <div className="text-end">
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => setShowConfirm(true)}
                      >
                        Submit Request
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => cancelRequest("faculty")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* UNIVERSITY ID */}
              <div className="col-12 col-md-6">
                <label className="form-label fw-semibold small">
                  University ID
                </label>

                <div className="control-row">
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <input
                      type="text"
                      className={`form-control shadow-sm border-0 bg-light ${
                        errors.universtyID ? "is-invalid" : ""
                      }`}
                      placeholder="Enter 9-digits"
                      value={personal.universtyID}
                      onChange={(e) => {
                        const val = e.target.value;
                        setPersonal((p) => ({ ...p, universtyID: val }));
                        validateField("universtyID", val);
                      }}
                      readOnly
                      onFocus={removeReadOnly}
                    />
                  </div>

                  <div className="control-actions">
                    {renderStatusBadge("universtyID")}
                    {renderActionButton("universtyID")}
                  </div>
                </div>

                {requestOpen.universtyID && (
                  <div className="mt-2 border rounded-3 p-3 bg-light">
                    <label className="form-label small">
                      New University ID
                    </label>
                    <input
                      className={`form-control mb-2 ${errors.newValue ? "is-invalid" : ""}`}
                      value={requestPayload.newValue}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          newValue: e.target.value,
                        }))
                      }
                      placeholder="9 digits"
                    />
                    {errors.newValue && (
                      <div className="invalid-feedback small">
                        {errors.newValue}
                      </div>
                    )}

                    <label className="form-label small">Reason</label>
                    <textarea
                      className={`form-control mb-2 ${errors.reason ? "is-invalid" : ""}`}
                      rows={2}
                      value={requestPayload.reason}
                      onChange={(e) =>
                        setRequestPayload((p) => ({
                          ...p,
                          reason: e.target.value,
                        }))
                      }
                    />
                    {errors.reason && (
                      <div className="invalid-feedback small">
                        {errors.reason}
                      </div>
                    )}

                    <div className="text-end">
                      <button
                        className="btn btn-sm btn-primary me-2"
                        onClick={() => setShowConfirm(true)}
                      >
                        Submit Request
                      </button>
                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => cancelRequest("universtyID")}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="text-end mt-4">
              <button
                disabled={
                  loadingAction === "Profile update" ||
                  !isPersonalDirty() ||
                  Boolean(errors.name) ||
                  Boolean(errors.phone)
                }
                onClick={handleSavePersonal}
                className="btn btn-primary px-3 px-md-4 rounded-3 w-100 w-md-auto"
              >
                {loadingAction === "Profile update"
                  ? "Saving..."
                  : "Save Changes"}
              </button>
            </div>
          </section>

          {/* SECURITY */}
          <section className="mb-4 bg-white p-3 p-md-4 rounded-4 shadow-sm">
            <h4
              className="mb-4 fw-semibold d-flex align-items-center"
              style={{ color: "#0d6efd", fontSize: "1.2rem" }}
            >
              <ShieldLockFill className="me-2" size={20} /> Security
            </h4>

            <h6 className="fw-semibold mb-3 text-secondary small">
              Change Password
            </h6>

            <div className="row g-3">
              {["old", "newPassword", "confirm"].map((field, idx) => (
                <div key={idx} className="col-12 col-md-4">
                  <input
                    type="password"
                    autoComplete={
                      field === "old" ? "current-password" : "new-password"
                    }
                    className={`form-control shadow-sm border-0 bg-light ${errors[field] ? "is-invalid" : ""}`}
                    placeholder={
                      field === "old"
                        ? "Old Password"
                        : field === "newPassword"
                          ? "New Password"
                          : "Confirm Password"
                    }
                    value={passwords[field]}
                    onChange={(e) => {
                      const value = e.target.value;
                      setPasswords({ ...passwords, [field]: value });
                      validateField(field, value);
                    }}
                    readOnly
                    onFocus={removeReadOnly}
                  />
                  {errors[field] && (
                    <div className="invalid-feedback small">
                      {errors[field]}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="text-end mt-3">
              <button
                disabled={
                  loadingAction === "Password update" ||
                  !passwords.old ||
                  !passwords.newPassword ||
                  !passwords.confirm ||
                  errors.old ||
                  errors.newPassword ||
                  errors.confirm ||
                  passwords.newPassword !== passwords.confirm ||
                  passwords.newPassword === passwords.old
                }
                onClick={handleUpdatePassword}
                className="btn btn-success px-3 px-md-4 rounded-3 w-100 w-md-auto"
              >
                {loadingAction === "Password update"
                  ? "Updating..."
                  : "Update Password"}
              </button>
            </div>

            {/* Forgot Password */}
            <div className="mt-4">
              <h6 className="fw-semibold text-secondary mb-2 small">
                Forgot Password?
              </h6>

              {!otpStep ? (
                <>
                  <p className="small text-muted">
                    Click below to receive an OTP via email.
                  </p>

                  {/* عرض رسائل خطأ/معلومات فوق الزرار */}
                  {otpMessage && (
                    <div className="alert alert-info small" role="alert">
                      {otpMessage}
                      {otpRemaining !== null && (
                        <span className="d-block mt-1">
                          Remaining attempts: {otpRemaining}
                        </span>
                      )}
                    </div>
                  )}
                  {otpError && (
                    <div className="alert alert-danger small" role="alert">
                      {otpError}
                    </div>
                  )}

                  <button
                    className="btn btn-outline-primary btn-sm rounded-3"
                    onClick={() => handleSendOTP("resetPassword")}
                    disabled={otpLoading}
                    type="button"
                  >
                    {otpLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Sending...
                      </>
                    ) : (
                      "Send OTP"
                    )}
                  </button>
                </>
              ) : (
                <div className="mt-3 border rounded-4 p-3 bg-light">
                  {/* show any message at top of the OTP card */}
                  {otpMessage && (
                    <div className="alert alert-info small" role="alert">
                      {otpMessage}
                      {otpRemaining !== null && (
                        <span className="d-block mt-1">
                          Remaining attempts: {otpRemaining}
                        </span>
                      )}
                    </div>
                  )}
                  {otpError && (
                    <div className="alert alert-danger small" role="alert">
                      {otpError}
                    </div>
                  )}

                  <label className="form-label small">Enter OTP</label>
                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control mb-2 shadow-sm border-0 ${errors.otp ? "is-invalid" : ""}`}
                    placeholder="Enter 6-digit OTP"
                    value={otpData.otp}
                    onChange={(e) => {
                      const value = e.target.value;
                      setOtpData((p) => ({ ...p, otp: value }));
                      validateField("otp", value);
                    }}
                  />
                  {errors.otp && (
                    <div className="invalid-feedback small">{errors.otp}</div>
                  )}

                  <input
                    type="password"
                    autoComplete="new-password"
                    className={`form-control mb-2 shadow-sm border-0 ${
                      errors.newPass ? "is-invalid" : ""
                    }`}
                    placeholder="New Password"
                    value={otpData.newPass}
                    onChange={(e) => {
                      const value = e.target.value;
                      setOtpData((p) => ({ ...p, newPass: value }));
                      validateField("newPass", value);
                    }}
                    readOnly
                    onFocus={removeReadOnly}
                  />
                  {errors.newPass && (
                    <div className="invalid-feedback small">
                      {errors.newPass}
                    </div>
                  )}

                  <input
                    type="password"
                    autoComplete="new-password"
                    className={`form-control mb-3 shadow-sm border-0 ${
                      errors.confirmPass ? "is-invalid" : ""
                    }`}
                    placeholder="Confirm Password"
                    value={otpData.confirmPass}
                    onChange={(e) => {
                      const value = e.target.value;
                      setOtpData((p) => ({ ...p, confirmPass: value }));
                      validateField("confirmPass", value);
                    }}
                    readOnly
                    onFocus={removeReadOnly}
                  />
                  {errors.confirmPass && (
                    <div className="invalid-feedback small">
                      {errors.confirmPass}
                    </div>
                  )}

                  <div className="text-end">
                    <button
                      disabled={loadingAction === "Password reset"}
                      onClick={handleResetPasswordWithOTP}
                      className="btn btn-primary btn-sm me-2 rounded-3"
                      type="button"
                    >
                      {loadingAction === "Password reset"
                        ? "Processing..."
                        : "Reset Password"}
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm rounded-3"
                      onClick={() => {
                        setOtpStep(false);
                        setOtpMessage(null);
                        setOtpError(null);
                      }}
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>

          {/* NOTIFICATIONS */}
          <section className="mb-4 bg-white p-3 p-md-4 rounded-4 shadow-sm">
            <h4
              className="mb-4 fw-semibold d-flex align-items-center"
              style={{ color: "#0d6efd", fontSize: "1.2rem" }}
            >
              <BellFill className="me-2" size={20} /> Notifications
            </h4>

            <div className="form-check form-switch ms-2">
              <input
                className="form-check-input"
                type="checkbox"
                id="notifSwitch"
                checked={notificationStatus}
                onChange={handleToggleNotification}
                disabled={notifLoading}
              />

              <label
                className="form-check-label fw-semibold small"
                htmlFor="notifSwitch"
              >
                {notificationStatus
                  ? "Disable Notifications"
                  : "Enable Notifications"}
              </label>
            </div>
            {/* رسالة خطأ لو حصلت */}
            {notifError && (
              <div className="text-danger small mt-1">{notifError}</div>
            )}
            {/* لودر صغير */}
            {notifLoading && (
              <div className="small text-muted mt-1">Updating...</div>
            )}
          </section>

          {/* ACCOUNT */}
          <section className="bg-white p-3 p-md-4 rounded-4 shadow-sm">
            <h4
              className="mb-4 fw-semibold d-flex align-items-center"
              style={{ color: "#0d6efd", fontSize: "1.2rem" }}
            >
              <BoxArrowRight className="me-2" size={20} /> Account
            </h4>

            <div className="d-flex flex-column flex-md-row gap-3 align-items-start">
              <button
                disabled={loadingAction === "Logout"}
                onClick={() => LogoutFun()}
                className="btn btn-outline-secondary px-4 rounded-3 w-100 w-md-auto"
              >
                {loadingAction === "Logout" ? "Processing..." : "Logout"}
              </button>

              {!deleteOtpStep ? (
                <>
                  {/* رسائل زي Forgot Password */}
                  {deleteOtpMessage && (
                    <div className="alert alert-info small" role="alert">
                      {deleteOtpMessage}
                      {deleteOtpRemaining !== null && (
                        <span className="d-block mt-1">
                          Remaining attempts: {deleteOtpRemaining}
                        </span>
                      )}
                    </div>
                  )}
                  {deleteOtpError && (
                    <div className="alert alert-danger small" role="alert">
                      {deleteOtpError}
                    </div>
                  )}

                  <button
                    className="btn btn-outline-danger px-4 rounded-3 w-100 w-md-auto"
                    onClick={() => setShowDeleteModal(true)}
                    disabled={deleteOtpLoading}
                    type="button"
                  >
                    {deleteOtpLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Sending...
                      </>
                    ) : (
                      <>
                        <TrashFill className="me-1" /> Delete Account
                      </>
                    )}
                  </button>
                </>
              ) : (
                <div
                  className="w-100 border rounded-4 p-3 bg-light mt-2"
                  style={{ maxWidth: "400px" }}
                >
                  {/* رسائل فوق الكارد */}
                  {deleteOtpMessage && (
                    <div className="alert alert-info small">
                      {deleteOtpMessage}
                      {deleteOtpRemaining !== null && (
                        <div className="mt-1">
                          Remaining attempts: {deleteOtpRemaining}
                        </div>
                      )}
                    </div>
                  )}
                  {deleteOtpError && (
                    <div className="alert alert-danger small">
                      {deleteOtpError}
                    </div>
                  )}

                  <label className="form-label small fw-semibold">
                    Enter OTP
                  </label>
                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control shadow-sm mb-2 border-0 ${
                      errors.otp ? "is-invalid" : ""
                    }`}
                    placeholder="Enter OTP"
                    value={otpData.otp}
                    onChange={(e) => {
                      const v = e.target.value;
                      setOtpData((p) => ({ ...p, otp: v }));
                      validateField("otp", v);
                    }}
                  />
                  {errors.otp && (
                    <div className="invalid-feedback small">{errors.otp}</div>
                  )}

                  <div className="text-end">
                    <button
                      disabled={loadingAction === "Account deletion"}
                      onClick={handleConfirmDelete}
                      className="btn btn-danger btn-sm me-2 rounded-3"
                      type="button"
                    >
                      {loadingAction === "Account deletion"
                        ? "Processing..."
                        : "Confirm Delete"}
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm rounded-3"
                      onClick={() => {
                        setDeleteOtpStep(false);
                        setDeleteOtpMessage(null);
                        setDeleteOtpError(null);
                      }}
                      type="button"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </div>
      </div>
      <ConfirmModal
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false);
          submitRequest();
        }}
        requestPayload={requestPayload}
      />
      {showDeleteModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 rounded-4 shadow-lg">
              <div className="modal-header bg-danger text-white rounded-top-4">
                <h5 className="modal-title">⚠️ Dangerous Action</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p className="fw-semibold text-danger">
                  This action is irreversible.
                </p>
                <p className="small">
                  Your account will be <b>disabled immediately</b>.
                  <br />
                  You will <b>NOT be able</b> to:
                </p>
                <ul className="small">
                  <li>Login again</li>
                  <li>Create a new account using the same email</li>
                </ul>
                <p className="small">
                  The account will remain stored for <b>30 days</b> then deleted
                  permanently.
                </p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    setShowDeleteModal(false);
                    handleSendDeleteOTP();
                  }}
                >
                  Yes, Delete My Account
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Popup Message */}
      {popup.show && (
        <PopupMessage
          type={popup.type}
          message={popup.message}
          onClose={() => setPopup({ ...popup, show: false })}
        />
      )}
    </>
  );
}
